import { FilterMetadataApiWithCountReturn, WaterProvider } from "../misc";
import { Category, CategoryChart } from "../processors";
import { fetchCategoryChartParam } from "./fetchCategoryChartParam";
import { CategoryChartQueryFn } from "./types";
import * as queryFns from "../categoryChartQueryFns";
import { CategoryChartData } from "./types";
import { fetchCategoryChartVisibility } from "./fetchCategoryChartVisibility";

export const fetchCategoryChartData = async (
    metadata: FilterMetadataApiWithCountReturn,
    category: Category,
    providers?: WaterProvider[],
    categoryChart?: CategoryChart
): Promise<CategoryChartData> => {
    const defaultRet = null;

    if (!metadata || !providers || !categoryChart || !queryFns[categoryChart?.queryFn]) return defaultRet;

    const params = await fetchCategoryChartParam(
        metadata,
        providers?.map(d => d.adminId)?.filter(d => d != null && d.toString().trim() !== "") ?? [],
        categoryChart
    );
    return (queryFns[categoryChart?.queryFn] as CategoryChartQueryFn)({
        ...params,
        category,
        providers: providers.filter(d => d != null)
    });
};

export const fetchCategoryChartDataWithVisibility = async (
    metadata: FilterMetadataApiWithCountReturn,
    category: Category,
    providers?: WaterProvider[],
    categoryChart?: CategoryChart
): Promise<CategoryChartData> => {
    if (!metadata) return null;

    const visibile = await fetchCategoryChartVisibility(
        metadata,
        providers?.map(d => d.adminId)?.filter(d => d != null && d.toString().trim() !== "") ?? [],
        categoryChart
    );

    if (!visibile) return null;

    return fetchCategoryChartData(metadata, category, providers, categoryChart);
};
